import React, { memo, useState, FC, useEffect } from 'react';
import { Dropdown, Collapse, Modal } from 'antd';
import classNames from 'classnames';
import { languageDict, languageMenuItems } from '@/utils/constants';
import { useRouter } from 'next/router';
import Image from 'next/image';
import ContactForm from '../ContactForm';
import { AppState } from '@/store';
import { shallowEqual, useSelector } from 'react-redux';
import { changeArea } from '@/store/slices/headerAndFooterSlice';
import { useAppContext } from '@/hooks/AppContext';
import { useSubscriptionConfig } from '@/hooks/use-subscription-config';
import { FooterProps } from './Footer.types';
import styles from './Footer.module.scss';

export const Footer: FC<FooterProps> = memo(props => {
  const router = useRouter();
  const subscriptionConfig = useSubscriptionConfig();
  const { areaKey, setAreaKey } = useAppContext();
  const [lanOpen, setLanOpen] = useState(false);
  const [lanPCOpen, setLaPCnOpen] = useState(false);
  const [mAreaOpen, setMAreaOpen] = useState(false);
  const [PCAreaOpen, setPCAreaOpen] = useState(false);
  const { articleData, language, footers } = props;

  const handleLanOpen = (flag: boolean) => {
    setLanOpen(flag);
  };
  const handlePCLanOpen = (flag: boolean) => {
    setLaPCnOpen(flag);
  };

  const handleAreaOpen = (flag: boolean) => {
    setMAreaOpen(flag);
  };
  const handlePCAreaOpen = (flag: boolean) => {
    setPCAreaOpen(flag);
  };

  const changeLanguage = (e: any) => {
    setLanOpen(false);
    setLaPCnOpen(false);

    if (
      (router.pathname == '/blog/[category]/[article]' &&
        articleData?.languages == 'CH_Only' &&
        e.key == 'en') ||
      (router.pathname == '/blog/[category]/[article]' &&
        articleData?.languages == 'EN_Only' &&
        e.key == 'zh')
    ) {
      showModal();
      return;
    }
    const safeUrl = encodeURI(
      `/${e.key}${location.pathname.replace(/^\/(zh|en)\b/, '')}${location.search}`
    );
    router.push(safeUrl);
  };

  const handleChangeArea = (e: any) => {
    setAreaKey(e.key);
    setMAreaOpen(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = (language: string) => {
    setIsModalOpen(false);
    language === 'en'
      ? router.push({
          pathname: '/en/blog'
        })
      : router.push({
          pathname: '/zh/blog'
        });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const footer: any = footers?.length > 0 ? footers[0] : {};

  const areaDict: any = {};
  const countryData: any =
    footer && footer.country_list && footer.country_list[0] ? footer.country_list[0] : {};
  const countryItemList =
    countryData && countryData.country_link_list
      ? countryData.country_link_list.map((item: any) => {
          const country_link = item.country_link;
          if (country_link.link.href && country_link.link.title) {
            areaDict[country_link.link.href] = country_link.link.title;
          }
          return { label: country_link.link.title, key: country_link.link.href };
        })
      : [];

  const { Panel } = Collapse;

  const logoData = footer.logo || {};
  const logoIcon = logoData.icon || {};
  const logoUrl = logoIcon?.url || '';
  const logoLink = logoData.link?.href || '';
  const openInNewTab = logoData.open_new_tab || null;

  const [collActiveKey, setCollActiveKey] = useState(0);

  const genExtra = (key: number, activeKey: number) => {
    return (
      <Image
        src={key === activeKey ? '/blog/icon/Reduce.svg' : '/blog/icon/Plus.svg'}
        className={classNames(
          styles.Option_Right_Icon,
          key === activeKey ? styles.Rotate_Icon : ''
        )}
        alt={''}
        width={16}
        height={16}
      />
    );
  };

  return (
    <div className={styles.footer}>
      {language.origin === 'zh' && subscriptionConfig && (
        <div className={styles.footer_subscription} id="blog-subscription">
          <div className={styles.footer_subscription_form}>
            <ContactForm />
          </div>
          <Image
            className={styles.footer_subscription_image}
            alt={'footer-subscription'}
            src="/blog/icon/footer-subscription.svg"
            width={496}
            height={200}
          />
        </div>
      )}

      <footer className={styles.Footer_Pc}>
        <div className={classNames(styles.MuiContainer_root, styles.MuiContainer_maxWidthXl)}>
          <div className={styles.Footer_Pc_Wrap}>
            <a href={logoLink} target={openInNewTab ? '_blank' : ''} rel="noopener noreferrer">
              <Image src={logoUrl} className={styles.Logo} alt={''} width={105} height={35} />
            </a>
            <div className={styles.Footer_Content}>
              <div className={styles.Footer_Left_Content}>
                <div className={styles.Language_Area}>
                  <div className={styles.Change_Language}>
                    <Image src="/blog/icon/Earth.svg" alt={''} width={15} height={14} />
                    <Dropdown
                      trigger={['click']}
                      onOpenChange={handlePCLanOpen}
                      open={lanPCOpen}
                      placement="bottomLeft"
                      dropdownRender={menu => (
                        <ul
                          className={classNames(
                            styles.M_Language_Options_Wrapper,
                            language.origin === 'zh'
                              ? styles.M_Language_Options_Wrapper_ZH
                              : styles.M_Language_Options_Wrapper_EN
                          )}
                        >
                          {languageMenuItems.map((item: any) => (
                            <li
                              className={classNames(
                                styles.Language_Item,
                                languageDict[language.origin] === item.label
                                  ? styles.Selected_Lan
                                  : ''
                              )}
                              key={item.key}
                              onClick={() => changeLanguage(item)}
                            >
                              <span className={styles.Language_Label}>{item.label}</span>
                              {languageDict[language.origin] === item.label ? (
                                <Image
                                  src="/blog/icon/Tick.svg"
                                  className={styles.Tick}
                                  alt={''}
                                  width={11}
                                  height={9}
                                />
                              ) : (
                                ''
                              )}
                              {languageDict[language.origin] === item.label ? (
                                <Image
                                  src="/blog/icon/TickWhite.svg"
                                  className={styles.Tick_White}
                                  alt={''}
                                  width={11}
                                  height={9}
                                />
                              ) : (
                                ''
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    >
                      <span className={styles.Language_Menu}>
                        <span>{languageDict[language.value]}</span>
                        <Image
                          src="/blog/icon/Sort.svg"
                          alt={''}
                          width={16}
                          height={16}
                          className={styles.Sort_Icon}
                        />
                      </span>
                    </Dropdown>
                  </div>

                  <div className={styles.Dividing_Line}></div>

                  <div className={styles.Change_Area}>
                    <span>{countryData.pre_text}</span>

                    <Dropdown
                      trigger={['click']}
                      onOpenChange={handlePCAreaOpen}
                      open={PCAreaOpen}
                      dropdownRender={menu => (
                        <ul
                          className={classNames(
                            styles.Area_Options_Wrapper,
                            language.origin === 'zh'
                              ? styles.Area_Options_Wrapper_ZH
                              : styles.Area_Options_Wrapper_EN
                          )}
                        >
                          {countryItemList.map((item: any) => (
                            <a
                              key={item.key}
                              href={item.key}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <li
                                className={classNames(
                                  styles.Area_Item,
                                  areaKey === item.key ? styles.Selected_Area : ''
                                )}
                                onClick={() => handleChangeArea(item)}
                              >
                                <span>{item.label}</span>
                                {areaKey === item.key ? (
                                  <Image
                                    src="/blog/icon/Tick.svg"
                                    className={styles.Tick}
                                    alt={''}
                                    width={11}
                                    height={9}
                                  />
                                ) : (
                                  ''
                                )}
                                {areaKey === item.key ? (
                                  <Image
                                    src="/blog/icon/TickWhite.svg"
                                    className={styles.Tick_White}
                                    alt={''}
                                    width={11}
                                    height={9}
                                  />
                                ) : (
                                  ''
                                )}
                              </li>
                            </a>
                          ))}
                        </ul>
                      )}
                    >
                      <span className={styles.Area_Menu}>
                        <span className={styles.Area_Result}>{areaDict[areaKey]}</span>
                        <Image src="/blog/icon/Sort.svg" alt={''} width={16} height={16} />
                      </span>
                    </Dropdown>
                  </div>
                </div>

                <div className={styles.Sharing_Content}>
                  <div className={styles.Phone_Number}>
                    <a href={footer?.call_information?.link?.href} className={styles.Phone_Link}>
                      <span className={styles.Phone_Icon}>
                        <Image
                          src="/blog/icon/Phone.svg"
                          alt={''}
                          width={20}
                          height={20}
                          className={styles.Icon}
                        />
                        <Image
                          src="/blog/icon/PhoneActive.svg"
                          alt={''}
                          width={25}
                          height={25}
                          className={styles.Icon_Active}
                        />
                      </span>
                      <span>{footer?.call_information?.link?.title}</span>
                    </a>
                  </div>

                  <div className={styles.Social_Medial_sharing}>
                    <a href="https://www.facebook.com/FWD.HK.MO/" target="_blank">
                      <Image
                        src="/blog/icon/FacebookBlue.svg"
                        alt={''}
                        width={40}
                        height={40}
                        className={styles.Icon}
                      />
                    </a>
                    <a href="https://www.youtube.com/FWDHK" target="_blank">
                      <Image
                        src="/blog/icon/IconYoutube.png"
                        alt={''}
                        width={34}
                        height={24}
                        className={styles.Icon}
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className={styles.Footer_Right_Content}>
                {Array.isArray(footer?.sections) &&
                  footer?.sections.map((item: any, index: any) => (
                    <ul key={item?.major_grouping?._metadata?.uid}>
                      <li>
                        <a
                          href={
                            item?.major_grouping?.major_grouping_link.href
                              ? item?.major_grouping?.major_grouping_link.href
                              : ''
                          }
                          className={styles.Category_Title}
                        >
                          {item?.major_grouping?.major_grouping_link.title}
                        </a>
                      </li>
                      {item?.major_grouping?.sub_links.map((child: any) => (
                        <li key={child?.sub_link?._metadata?.uid}>
                          <a href={child?.sub_link?.link?.href}>{child?.sub_link?.link?.title}</a>
                        </li>
                      ))}
                    </ul>
                  ))}

                <ul>
                  {Array.isArray(footer?.other_links) &&
                    footer?.other_links.map((other: any) => (
                      <li key={other?.other_link?._metadata?.uid}>
                        <a href={other?.other_link?.link?.href} className={styles.Category_Title}>
                          {other?.other_link?.link?.title}
                        </a>

                        <ul className={styles.Sub_Links_Wrapper} style={{ marginTop: 12 }}>
                          {other?.other_link?.sub_links.map((child: any) => (
                            <li
                              className={styles.Other_Sub_Links}
                              key={child?.sub_link?._metadata?.uid}
                            >
                              <a href={child?.sub_link?.link?.href}>
                                {child?.sub_link?.link?.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            <div className={styles.Footer_Bottom}>
              <div className={styles.Website_Info}>
                {Array.isArray(footer?.sub_footer_links) &&
                  footer?.sub_footer_links.map((item: any) => (
                    <div className={styles.Website_Info_Item} key={item?.link?._metadata?.uid}>
                      <a href={item?.link?.link?.href}>{item?.link?.link?.title}</a>
                    </div>
                  ))}
              </div>

              <div className={styles.Copy_Right_Info}>
                <div className={styles.Company_Name}>
                  <span>{footer?.copyright_text}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <footer className={styles.Footer_Mobile}>
        <div className={styles.Web_Info}>
          <div className={styles.Header_Info}>
            {logoLink ? (
              <a href={logoLink} target={openInNewTab ? '_blank' : ''}>
                {logoUrl ? (
                  <Image src={logoUrl} className={styles.Logo} alt={''} width={96} height={32} />
                ) : (
                  ''
                )}
              </a>
            ) : (
              <>
                {logoUrl ? (
                  <Image src={logoUrl} className={styles.Logo} alt={''} width={96} height={32} />
                ) : (
                  ''
                )}
              </>
            )}
            <div className={styles.Phone_Number}>
              <a href={footer?.call_information?.link?.href} className={styles.Phone_Link}>
                <span className={styles.Phone_Icon}>
                  <Image
                    src="/blog/icon/Phone.svg"
                    alt={''}
                    width={20}
                    height={20}
                    className={styles.Icon}
                  />
                  <Image
                    src="/blog/icon/PhoneActive.svg"
                    alt={''}
                    width={25}
                    height={25}
                    className={styles.Icon_Active}
                  />
                </span>
                <span>{footer?.call_information?.link?.title}</span>
              </a>
            </div>
          </div>

          <Collapse
            className={classNames(
              language.origin === 'en' ? styles.Footer_Menu_EN : styles.Footer_Menu_ZH
            )}
            accordion
            bordered={false}
            expandIconPosition={'end'}
            onChange={res => setCollActiveKey(+res)}
          >
            {Array.isArray(footer.sections) &&
              footer.sections.map((item: any, index: number) => {
                const majorGrouping = item.major_grouping || {};
                const majorGroupingLink = majorGrouping.major_grouping_link || {};
                const majorGroupingUrl = majorGroupingLink.href || '';
                const majorGroupingTitle = majorGroupingLink.title || '';
                const majorGroupingMetadata = majorGrouping._metadata || {};
                const majorGroupingMetadataUid = majorGroupingMetadata.uid || '';
                const openInNewTab = majorGrouping.open_new_tab || null;
                const subLinksData = majorGrouping.sub_links || [];

                return (
                  <Panel
                    header={
                      <div className={styles.Option_Header}>
                        <span>
                          <Image
                            src="/blog/icon/ArrowR.svg"
                            width={13}
                            height={12}
                            alt={''}
                            className={styles.Option_Left_Icon}
                          />
                          {majorGroupingUrl ? (
                            <a
                              href={majorGroupingUrl}
                              target={openInNewTab ? '_blank' : ''}
                              className={styles.Option_Left_Title}
                            >
                              {majorGroupingTitle}
                            </a>
                          ) : (
                            <span className={styles.Option_Left_Title}>{majorGroupingTitle}</span>
                          )}
                        </span>
                      </div>
                    }
                    key={index + 1}
                    showArrow={false}
                    extra={genExtra(index + 1, collActiveKey)}
                  >
                    <ul className={styles.Option_List}>
                      {subLinksData.length > 0 &&
                        subLinksData.map((child: any) => {
                          const subLink = child.sub_link || {};
                          const subLinkMetadata = subLink._metadata || {};
                          const subLinkMetadataUid = subLinkMetadata.uid || '';
                          const subOpenInNewTab = subLink.open_new_tab || null;
                          const subLinkLink = subLink.link || {};
                          const subLinkTitle = subLinkLink.title || '';
                          const subLinkUrl = subLinkLink.href || '';

                          return (
                            <li key={subLinkMetadataUid}>
                              {subLinkUrl ? (
                                <a href={subLinkUrl} target={subOpenInNewTab ? '_blank' : ''}>
                                  {subLinkTitle}
                                </a>
                              ) : (
                                <span>{subLinkTitle}</span>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </Panel>
                );
              })}

            {Array.isArray(footer.other_links) &&
              footer.other_links.length > 0 &&
              footer.other_links.map((other: any, index: number) => {
                const otherLink = other.other_link || {};
                const otherLinkMeta = otherLink._metadata || {};
                const otherLinkMetaUid = otherLinkMeta.uid || '';
                const otherLinkLink = otherLink.link || {};
                const otherLinkLinkTitle = otherLinkLink.title || '';
                const otherLinkLinkUrl = otherLinkLink.href || '';
                const otherSubLinkData = otherLink.sub_links || [];

                return (
                  <Panel
                    header={
                      <div className={styles.Option_Header}>
                        <span>
                          <Image
                            src="/blog/icon/ArrowR.svg"
                            width={13}
                            height={12}
                            alt={''}
                            className={styles.Option_Left_Icon}
                          />
                          {otherLinkLinkUrl ? (
                            <a
                              href={otherLinkLinkUrl}
                              target={openInNewTab ? '_blank' : ''}
                              className={styles.Option_Left_Title}
                            >
                              {otherLinkLinkTitle}
                            </a>
                          ) : (
                            <span className={styles.Option_Left_Title}>{otherLinkLinkTitle}</span>
                          )}
                        </span>
                      </div>
                    }
                    key={index + 1 + footer.sections.length}
                    showArrow={false}
                    extra={
                      otherSubLinkData.length > 0
                        ? genExtra(index + 1 + footer.sections.length, collActiveKey)
                        : ''
                    }
                    collapsible={otherSubLinkData.length < 1 ? 'disabled' : undefined}
                  >
                    <ul className={styles.Option_List}>
                      {otherSubLinkData.length > 0 &&
                        otherSubLinkData.map((child: any) => {
                          const otherSubLink = child.sub_link || {};
                          const otherSubLinkMetadata = otherSubLink._metadata || {};
                          const otherSubLinkMetadataUid = otherSubLinkMetadata.uid || '';
                          const otherSubOpenInNewTab = otherSubLink.open_new_tab || null;
                          const otherSubLinkLink = otherSubLink.link || {};
                          const otherSubLinkTitle = otherSubLinkLink.title || '';
                          const otherSubLinkUrl = otherSubLinkLink.href || '';

                          return (
                            <li key={otherSubLinkMetadataUid}>
                              {otherSubLinkUrl ? (
                                <a
                                  href={otherSubLinkUrl}
                                  target={otherSubOpenInNewTab ? '_blank' : ''}
                                >
                                  {otherSubLinkTitle}
                                </a>
                              ) : (
                                <span>{otherSubLinkTitle}</span>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </Panel>
                );
              })}
          </Collapse>

          <div className={styles.Social_Medial_sharing}>
            <a href="https://www.facebook.com/FWD.HK.MO/" target="_blank">
              <Image
                src="/blog/icon/FacebookBlue.svg"
                alt={''}
                width={40}
                height={40}
                className={styles.Icon}
              />
            </a>
            <a href="https://www.youtube.com/FWDHK" target="_blank">
              <Image
                src="/blog/icon/IconYoutube.png"
                alt={''}
                width={34}
                height={24}
                className={styles.Icon}
              />
            </a>
          </div>

          <div className={styles.Area_Wrapper}>
            <div className={styles.Change_Language}>
              <Image src="/blog/icon/Earth.svg" alt={''} width={15} height={14} />
              <Dropdown
                trigger={['click']}
                onOpenChange={handleLanOpen}
                open={lanOpen}
                placement="bottomLeft"
                dropdownRender={menu => (
                  <ul
                    className={classNames(
                      styles.M_Language_Options_Wrapper,
                      language.origin === 'zh'
                        ? styles.M_Language_Options_Wrapper_ZH
                        : styles.M_Language_Options_Wrapper_EN
                    )}
                  >
                    {languageMenuItems.map((item: any) => (
                      <li
                        className={classNames(
                          styles.Language_Item,
                          languageDict[language.origin] === item.label ? styles.Selected_Lan : ''
                        )}
                        key={item.key}
                        onClick={() => changeLanguage(item)}
                      >
                        <span className={styles.Language_Label}>{item.label}</span>
                        {languageDict[language.origin] === item.label ? (
                          <Image
                            src="/blog/icon/Tick.svg"
                            className={styles.Tick}
                            alt={''}
                            width={11}
                            height={9}
                          />
                        ) : (
                          ''
                        )}
                        {languageDict[language.origin] === item.label ? (
                          <Image
                            src="/blog/icon/TickWhite.svg"
                            className={styles.Tick_White}
                            alt={''}
                            width={11}
                            height={9}
                          />
                        ) : (
                          ''
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              >
                <span className={styles.Language_Menu}>
                  <span>{languageDict[language.value]}</span>
                  <Image
                    src="/blog/icon/Sort.svg"
                    alt={''}
                    width={16}
                    height={16}
                    className={styles.Sort_Icon}
                  />
                </span>
              </Dropdown>
            </div>

            <div className={styles.Change_Area}>
              <span>{countryData.pre_text}</span>

              <Dropdown
                trigger={['click']}
                onOpenChange={handleAreaOpen}
                open={mAreaOpen}
                placement="topLeft"
                dropdownRender={menu => (
                  <ul
                    className={classNames(
                      styles.Area_Options_Wrapper,
                      language.origin === 'zh'
                        ? styles.Area_Options_Wrapper_ZH
                        : styles.Area_Options_Wrapper_EN
                    )}
                  >
                    {countryItemList.map((item: any) => (
                      <li
                        key={item.key}
                        className={classNames(
                          styles.Area_Item,
                          areaKey === item.key ? styles.Selected_Area : ''
                        )}
                        onClick={() => handleChangeArea(item)}
                      >
                        <span>{item.label}</span>
                        {areaKey === item.key ? (
                          <Image
                            src="/blog/icon/Tick.svg"
                            className={styles.Tick}
                            alt={''}
                            width={11}
                            height={9}
                          />
                        ) : (
                          ''
                        )}
                        {areaKey === item.key ? (
                          <Image
                            src="/blog/icon/TickWhite.svg"
                            className={styles.Tick_White}
                            alt={''}
                            width={11}
                            height={9}
                          />
                        ) : (
                          ''
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              >
                <span className={styles.Area_Result}>
                  <span className={styles.Result_Option}>{areaDict[areaKey]}</span>
                  <Image
                    src="/blog/icon/Sort.svg"
                    alt={''}
                    width={16}
                    height={16}
                    className={styles.Sort_Icon}
                  />
                </span>
              </Dropdown>
            </div>
          </div>

          <div className={styles.Website_Info}>
            {Array.isArray(footer?.sub_footer_links) &&
              footer?.sub_footer_links.map((item: any) => (
                <div className={styles.Website_Info_Item} key={item?.link?._metadata?.uid}>
                  <a href={item?.link?.link?.href}>{item?.link?.link?.title}</a>
                </div>
              ))}
          </div>

          <div className={styles.Copy_Right_Info}>
            <div className={styles.Company_Name}>
              <span>{footer?.copyright_text}</span>
            </div>
          </div>
        </div>
        <Modal
          className={classNames(
            styles.Header_Modal,
            language.value === 'en' ? styles.Header_Modal_EN : styles.Header_Modal_ZH
          )}
          width={632}
          centered
          open={isModalOpen}
          onOk={() => handleOk(language.value)}
          onCancel={handleCancel}
          okText={language.value == 'en' ? 'Explore' : '瀏覽更多'}
          maskClosable={false}
          cancelText={language?.value == 'en' ? 'Stay on page' : '繼續瀏覽'}
        >
          <h3 className={styles.Modal_Title}>
            {language?.value == 'en'
              ? 'This content might not be in your language'
              : '此內容可能沒有您想要的語言版本'}
          </h3>
          <p className={styles.Modal_Text}>
            {language?.value == 'en'
              ? 'We are currently working to have this content in your language. You can choose to stay on this page, or proceed to explore other relevant contents.'
              : '我們正在努力提供您的語言版本。您可以選擇留在此頁或繼續探索其他相關內容。'}
          </p>
        </Modal>
      </footer>
    </div>
  );
});
